import { useEffect, useState } from "react";
import { LogOut, UserCheck } from "lucide-react";

/* Bandeau d'emprunt d'identité : permanent, non masquable, toujours en tête de
   page. Il rappelle qui regarde, au nom de qui, pour combien de temps encore,
   et si la session est en lecture seule. */

function remaining(expiresAt) {
  if (!expiresAt) return null;
  const end = typeof expiresAt === "number" ? expiresAt : Date.parse(expiresAt);
  if (Number.isNaN(end)) return null;
  return Math.max(0, Math.round((end - Date.now()) / 1000));
}

function format(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export default function ImpersonationBanner({ impersonation, onStop, onExpire, busy = false }) {
  const expiresAt = impersonation?.expiresAt;
  const [left, setLeft] = useState(() => remaining(expiresAt));

  useEffect(() => {
    setLeft(remaining(expiresAt));
    if (!expiresAt) return undefined;
    const timer = setInterval(() => {
      const value = remaining(expiresAt);
      setLeft(value);
      if (value === 0) onExpire?.();
    }, 1000);
    return () => clearInterval(timer);
  }, [expiresAt, onExpire]);

  if (!impersonation) return null;

  const { subjectName, subjectEmail, adminName, readOnly, reason } = impersonation;

  return (
    <div className="adm-imp" role="alert" data-testid="impersonation-banner">
      <UserCheck size={16} />
      <span className="adm-imp-text">
        <strong>Vous consultez ce compte en tant qu'administrateur.</strong>{" "}
        <span>
          {subjectName || subjectEmail} · emprunt ouvert par {adminName}
          {reason ? ` · motif : ${reason}` : ""}
        </span>
        {readOnly && <span className="adm-imp-ro">Lecture seule</span>}
      </span>
      {left !== null && (
        <span className={`adm-imp-timer${left <= 60 ? " is-low" : ""}`} data-testid="impersonation-timer">
          <span className="adm-sr">Temps restant</span>
          {left === 0 ? "Session expirée" : format(left)}
        </span>
      )}
      <button type="button" onClick={onStop} disabled={busy} data-testid="impersonation-stop">
        <LogOut size={13} />Quitter l'emprunt
      </button>
    </div>
  );
}
